import React from 'react';
import { CreateButton, ExportButton } from 'react-admin';
import CardActions from '@material-ui/core/CardActions';

export const NormalActions = ({
  bulkActions, basePath, currentSort, displayedFilters, exporter, filters, filterValues,
  onUnselectItems, resource, selectedIds, showFilter, total, customClassName,
}) => (
  <CardActions>
    {bulkActions && React.cloneElement(bulkActions, {
      basePath,
      filterValues,
      resource,
      selectedIds,
      onUnselectItems,
    })}
    {filters && React.cloneElement(filters, {
      resource,
      showFilter,
      displayedFilters,
      filterValues,
      context: 'button',
    })}
    <CreateButton basePath={basePath} className={customClassName}/>
    <ExportButton
      disabled={total === 0}
      resource={resource}
      sort={currentSort}
      filter={filterValues}
      exporter={exporter}
    />
  </CardActions>
);
